import { Text, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { useContext } from 'react';
import NextLink from 'next/link';
import classNames from 'classnames/bind';

import { contextType, HeaderContext } from './Header';

import styles from './Header.module.scss';

const cx = classNames.bind(styles);

type TranslationLinkProps = {
  availableTranslations: string;
  translationText?: string;
  currentLanguage: string;
  currentPage: string;
};

const TranslationLink = (props: TranslationLinkProps): JSX.Element | null => {
  const { resetMobileMenu } = useContext(HeaderContext) as contextType;
  /* Uses only first language available at the moment. Needs updated when it's
    determined how we're handling multiple languages */
  const locale = props?.availableTranslations?.split(',')[0] ?? 'en';
  const { sitecoreContext } = useSitecoreContext();

  /*
    When broswer language is ready to be detected, uncomment the following two lines
    and add ', useEffect, useState' to line 2 imports
    navigator must appear in useEffect or it will throw an error
  */
  // const [browserLanguage, setBrowserLanguage] = useState('en');
  // useEffect(() => setBrowserLanguage(navigator.language), [setBrowserLanguage]);

  /**
   * If the translation link is not enabled or the text for the link
   * is not set we return null
   */
  if (!props || props.availableTranslations === '') return null;

  /**
   * Setting the href of the translation link based on the locale.
   * Prepending version if locale is not 'en'
   */
  const href = props.currentLanguage == 'en' ? props.currentPage : `/${locale}${props.currentPage}`;

  return (
    <li className={cx('translation-item')}>
      <NextLink
        href={href}
        locale={locale}
        className={cx('translation-link')}
        onClick={() => {
          resetMobileMenu();
        }}
      >
        <Text field={{ value: props.translationText }} encode={sitecoreContext.pageEditing} />
      </NextLink>
    </li>
  );
};

export default TranslationLink;
